// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2NTXl","right":"Footer_right__2KOTS","buttons":"Footer_buttons__1B0lz"};